import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// CRA'nın statik manifest.json'undaki "start_url" sabit olduğu için (her zaman "/app/"e çözülüyor),
// Android Chrome'da hangi sayfadan "Ana Ekrana Ekle" yapılırsa yapılsın kısayol hep aynı (yanlış)
// sayfayı açıyordu. Bu bileşen her sayfa değişiminde manifest'i O ANKİ sayfanın adresiyle yeniden
// üretip <link rel="manifest"> etiketini günceller — böylece "Ana Ekrana Ekle" o an açık olan
// sayfayı (örn. garson panelini) kısayol olarak kaydeder.
export default function DinamikManifest() {
  const location = useLocation();
  const oncekiBlobUrlRef = useRef(null);

  useEffect(() => {
    const manifestVerisi = {
      short_name: 'RestMenu',
      name: 'RestMenu',
      icons: [
        { src: `${process.env.PUBLIC_URL}/logo192.png`, type: 'image/png', sizes: '192x192' },
        { src: `${process.env.PUBLIC_URL}/logo512.png`, type: 'image/png', sizes: '512x512' }
      ],
      start_url: window.location.pathname + window.location.search,
      display: 'standalone',
      theme_color: '#1e2a3a',
      background_color: '#ffffff'
    };

    const blob = new Blob([JSON.stringify(manifestVerisi)], { type: 'application/json' });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.querySelector('link[rel="manifest"]');
    if (link) link.setAttribute('href', blobUrl);

    if (oncekiBlobUrlRef.current) URL.revokeObjectURL(oncekiBlobUrlRef.current);
    oncekiBlobUrlRef.current = blobUrl;
  }, [location.pathname, location.search]);

  return null;
}
